/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatDocForDisplay } from '../../../utils/format';
import { CellLink } from '../../../styles/ui/Link';

// ---------------------------------------------------------------------------
// Exibição da CONTA RECEBEDORA de uma cobrança (handoff 0082 §2.2).
//
// O backend devolve um `bankAccount` enxuto (whitelist de 5 campos) na listagem,
// na ficha e no grupo. Este componente é o único lugar que decide como essa
// conta aparece — apelido em cima, CNPJ embaixo — para que tabela, ficha e
// parcelamento não divirjam.
//
// ⚠️ `bankAccount` é NULLABLE. Hoje todas as cobranças têm conta (o backfill do
// 0080 preencheu o histórico e a emissão exige a conta desde a 2A.2), mas uma
// órfã criada por caminho não previsto não pode quebrar a tela: cai em "—".
// ---------------------------------------------------------------------------

const Wrapper = styled.span`
   display: inline-flex;
   flex-direction: column;
   gap: 1px;
   min-width: 0;
   text-align: left;

   .name {
      font-weight: 600;
      font-size: 0.8rem;
   }

   .doc {
      font-size: 0.68rem;
      color: ${({ theme }) => theme?.colors?.textMuted ?? '#666'};
      font-variant-numeric: tabular-nums;
   }
`;

export default function BankAccountTag({ account, to = null, showDoc = true }) {
   if (!account) return <span>—</span>;

   const name = account.account_name || account.account_owner_name || '—';
   const doc = formatDocForDisplay(account.account_doc_number);

   const nameNode = to ? (
      <CellLink to={to} className="name" onClick={(e) => e.stopPropagation()}>
         {name}
      </CellLink>
   ) : (
      <span className="name">{name}</span>
   );

   return (
      <Wrapper title={account.account_owner_name || undefined}>
         {nameNode}
         {showDoc && doc !== '—' && <span className="doc">{doc}</span>}
      </Wrapper>
   );
}

BankAccountTag.propTypes = {
   account: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      account_name: PropTypes.string,
      account_owner_name: PropTypes.string,
      account_doc_number: PropTypes.string,
      bank_name: PropTypes.string,
   }),
   // Quando informado, o apelido vira link (ex.: ficha da conta). O clique não
   // borbulha — em tabela de linha clicável, clicar no link não deve também
   // disparar a navegação da linha.
   to: PropTypes.string,
   showDoc: PropTypes.bool,
};
